import HeaderBanner from './HeaderBanner';
const AboutUs  = () => {
 
    return (
        <>
        <HeaderBanner heading={'Gallery'} imagePath="assets/images/banners/clietns.avif"/>
        <div className='section'>
            <div className="section" style={{ background: 'rgb(235, 230, 230)', paddingTop: '30px', paddingBottom: '30px' }}>
                
                 <div className="container">
                    <div className="mid-title text-center  mb-5 "><h2 className="heading-with-border">Gallery</h2></div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Bouncer.jpeg" alt="ignition" style={{ height: '273px' }} />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Bouncer.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Bouncer2.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Bouncer2.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Bouncer3.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Bouncer3.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Securityguard1.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Securityguard1.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Securityguard2.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Securityguard2.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Securityguard4.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Securityguard4.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Pantry1.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Pantry1.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Securityguard5.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Securityguard5.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Housekeeping2.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Housekeeping2.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Housekeeping.jpeg" alt="ignition" style={{ height: '238px' }} />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Housekeeping.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Escort1.jpg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Escort1.jpg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Securityguard3.jpeg" alt="ignition" style={{ height: '238px' }} />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Securityguard3.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Pantry2.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Pantry2.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Pantry3.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Pantry3.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="single-gallery-img">
                                <img src="assets/images/Gallery/Housekeeping3.jpeg" alt="ignition" />
                                <div className="gallery-caption">
                                    <p>
                                        <a href="assets/images/Gallery/Housekeeping3.jpeg" target="_blank" className="more gallery2">
                                            <i className="fa fa-fw fa-search-plus"></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                </div>
        </div>
        </>
    )
}

export default AboutUs;